import { useIntl } from 'react-intl'
import Caption from 'LuxKit/Typography/Caption'
import { formatInclusionsTitleBonus } from 'constants/inclusions'

interface Props {
  category: 'exclusive' | 'night-extra'
  minimumStay?: number
  selectedDuration?: number
}

function AccommodationPackageExtraInclusionsHeading({ category, minimumStay, selectedDuration }: Props) {
  const intl = useIntl()
  const heading = category === 'exclusive' ? intl.formatMessage({
    id: 'h4Rw88NMeowHc_aaKYht',
    defaultMessage: 'Exclusive extras',
    description: 'Heading for included exclusive bundled experiences in a hotel package selection card',
  }) : minimumStay ? intl.formatMessage({
    id: 'Xqa1i2BD-9FLF0kxEcEa',
    defaultMessage: '{count}+ {count, plural, one {night} other {nights}} extras',
    description: 'Hotel package extras heading with the authoritative minimum stay required for every listed benefit',
  }, { count: minimumStay }) : selectedDuration && selectedDuration > 0 ? intl.formatMessage({
    id: '_DSMWvAZuB5UhSyQprRN',
    defaultMessage: '{count, plural, one {Extra inclusions for a # night stay} other {Extra inclusions for # night stays}}',
    description: 'Hotel package bonus heading for the selected stay length when the qualifying minimum stay is unknown',
  }, { count: selectedDuration }) : formatInclusionsTitleBonus(intl)

  return <Caption variant="medium" weight="bold" colour={category === 'exclusive' ? 'highlight-primary-dark' : 'success-dark'}>{heading}</Caption>
}

export default AccommodationPackageExtraInclusionsHeading
